
<button class="btn q-btn q-main m-2" (click)="getGrid()" title="actualiser"> Actualiser </button>

<button class="btn q-btn q-main m-2" (click)="OpenModal(ModalCycleDigitalLearning);"
        title="Affectation des cycles Digital Learning">
  <i class="fa-graduation-cap fas"> </i>Cycles Digital Learning
</button>


<fieldset class="q-fieldset">
  <legend>Digital-Learning</legend>
  <div class="col text-center"  *ngIf="!customgridParam?.cgParameters?.isDataLoaded"><i class="fas fa-spin fa-spinner fa-pulse q-c-main fa-5x"></i></div>
  <q-customgrid class='h-100 w-100'
                [customgridParam]="customgridParam"
                *ngIf="customgridParam?.cgParameters?.isDataLoaded"
                #agGrid>
  </q-customgrid>
</fieldset>


<ng-template #ModalCycleDigitalLearning let-modalCycleDigitalLearning>
  <div #header class="modal-header">
    <h5 class="modal-title q-bold q-c-main" id="ModalTitle">Cycles Digital Learning</h5>
    <button type="button" class="close" aria-label="Close" (click)="modalCycleDigitalLearning.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-xxl" >
    <q-cycle-elearning class="h-100"  [idStage]="service.Stage.Ident" (save)="modalCycleDigitalLearning.close('');getGrid()" ></q-cycle-elearning>    
  </div>
</ng-template>

